module.exports = __webpack_public_path__ + "img/logo-moca.758077df.jpg";